"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AlertDismiss;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AlertDismiss(_ref) {
  var handleDismiss = _ref.handleDismiss;

  return _react2.default.createElement(
    "button",
    {
      type: "button",
      className: "close",
      "aria-label": "Close",
      onClick: handleDismiss },
    _react2.default.createElement(
      "span",
      { "aria-hidden": "true" },
      "\xD7"
    )
  );
}

AlertDismiss.propTypes = {
  handleDismiss: _react.PropTypes.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/alerts/lib/components/dismiss/components/AlertDismiss.component.js
// module id = 357
// module chunks = 0 1 4